import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'MyContestList',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            pagination: {
                key: new Date().getTime(),
                refreshing: false,
                loading: false,
                finished: false,
                error: false,
                current: 0,
                list: []
            }
        }
    },
    methods: {
        async onRefresh() {
            this.pagination.refreshing = true
            try {
                let result = await contestApi.getIcreated(1)
                this.pagination.list = result.results
                this.pagination.current = 1
                this.pagination.finished = result.lastPage
            } catch (error) {
                this.$toast.fail(error.message)
            }
            this.pagination.refreshing = false
            this.pagination.loading = false
            this.pagination.error = false
            this.pagination.key = new Date().getTime()
            if (!this.pagination.finished) {
                this.onLoadMore()
            }
        },
        async onLoadMore() {
            let key = this.pagination.key
            this.pagination.loading = true
            this.pagination.error = false
            try {
                let result = await contestApi.getIcreated(this.pagination.current + 1)
                if (key !== this.pagination.key) return
                this.pagination.list = this.pagination.list.concat(result.results)
                this.pagination.current += 1
                this.pagination.finished = result.lastPage
            } catch (error) {
                if (key !== this.pagination.key) return
                this.pagination.error = true
            }
            this.pagination.loading = false
        }
    }
}
